import React, { useMemo } from 'react';
import style from './Result.scss';
import classnames from 'classnames';
import { Text, WEIGHTS, SIZES } from '../../../../PageElements/Text';
import { SearchResultName } from './SearchResultName/index';
import { Breadcrumbs, IBreadcrumbs } from './Breadcrumbs';
import { SearchResultSummary } from './SearchResultSummary';

export type IResult = {
  name: string;
  summary: string;
  link: string;
  isExternalLink: boolean;
  description: string;
  breadcrumbs: IBreadcrumbs[];
  _highlights: { [key: string]: string[] };
  httpMethod: string;
  type: string;
  viewerId: string;
};

export const Result = ({
  isHighlighted,
  searchResult,
  onSearchResultClick,
  relatedSitesMap,
}: {
  isHighlighted: boolean;
  searchResult: IResult;
  onSearchResultClick: (link: string) => any;
  relatedSitesMap: Map<string, string>;
}) => {
  const {
    name,
    summary = '',
    link,
    isExternalLink,
    description = '',
    breadcrumbs = [],
    _highlights,
    viewerId,
  } = searchResult;

  const type = searchResult.httpMethod || searchResult.type;

  const siteName = useMemo(() => relatedSitesMap.get(viewerId) || '', [
    relatedSitesMap,
  ]);

  return (
    <li
      data-highlighted={isHighlighted}
      data-hook="search-result"
      className={classnames({
        [style.highlighted]: isHighlighted,
        [style.result]: true,
      })}
    >
      <Text
        secondary
        size={SIZES.small}
        weight={WEIGHTS.thin}
        dataHook="breadcrumbs"
      >
        <Breadcrumbs siteName={siteName} breadcrumbs={breadcrumbs} />
      </Text>
      <SearchResultName
        type={type}
        name={name}
        link={link}
        isExternalLink={isExternalLink}
        onSearchResultClick={onSearchResultClick(link)}
      />
      <SearchResultSummary
        summary={summary}
        description={description}
        highlights={_highlights}
      />
      <div className={style.separator} />
    </li>
  );
};
